import { render, staticRenderFns } from "./LivePreviewItem.vue?vue&type=template&id=c1dc8c9e&scoped=true&"
import script from "./LivePreviewItem.vue?vue&type=script&lang=ts&"
export * from "./LivePreviewItem.vue?vue&type=script&lang=ts&"
import style0 from "./LivePreviewItem.vue?vue&type=style&index=0&id=c1dc8c9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dc8c9e",
  null
  
)

export default component.exports